<template id="priceQuotationTmpl">
	<div>

		<div class="font-weight-bold">{{ $t('msg.dataRelativeLastSave') }}</div>

		<!-- DISCLAIMER -->
		<v-alert dense type="info" color="#2A3B4D">{{ $t('msg.priceQuotationDisclaimer') }}</v-alert>

		<v-btn class="button-main" v-on:click="projectPdfDownload()"><v-icon left dark>picture_as_pdf</v-icon>{{ $t('btn.pdf')}} </v-btn>

		<!-- ESTIMATE - START -->
		<v-card class="mt-3 mb-3" v-if="estimate_obj != null">
			<v-card-subtitle>{{ $t('lbl.estimate_title_priceQuotation') }}</v-card-subtitle>

			<v-card-text>
				<v-row no-gutters> 
					<v-col cols="12">
						<strong>{{ $t('lbl.estimate_num_of_service') }}:&nbsp;{{ this.estimate_obj.num_services }}</strong>
					</v-col>
				</v-row>
				<div v-for="(amountObj, amountKey) in  this.estimate_obj.amounts" :key="amountKey" >
					<v-row no-gutters v-for="(value, currencyKey) in  amountObj" :key="currencyKey" >
						<v-col cols="12">
							<strong>{{ $t('lbl.estimate_amount_' + amountKey) }}:&nbsp;{{currencyKey}}&nbsp;{{$root.formatPrice(value)}}</strong>
						</v-col>
					</v-row>
				</div>
			</v-card-text>	

			<!-- ESTIMATE - END -->
		
		
			<v-card-subtitle>{{ $t('lbl.priceQuotationCostsDetails') }}</v-card-subtitle>
			
			<v-card-text>
				<div v-for="item in priceQuotation" :key="item.service_id" >
					<div v-if="item != null && item.service != null">
						<v-row no-gutters>
							<v-col cols="12" class="font-weight-bold">
								{{$root.findTranslationInList(item.service.service_name)}}
							</v-col>
						</v-row>

						<!-- PRICE QUOTATION - CONTENTS - START -->
						<div v-for="(contentItem, namecontent) in item.service.contents" :key="namecontent" >
							<v-row no-gutters>
								<v-col cols="12" md="6" class="pl-4 font-weight-bold">
									{{$root.findTranslationInList(contentItem.name)}}
								</v-col>
								<v-col cols="12" md="6">
									{{contentItem.price.currency}}&nbsp;{{ $root.formatPrice(getQuantityServiceContent(item.service_id, namecontent, null) * contentItem.price.value)}}
									<span v-if="contentItem.period">&nbsp;{{$t('lbl.contentPrice_' + contentItem.period)}}</span>
								</v-col>
							</v-row>	
							<!-- PRICE QUOTATION - ADDITIONAL CONTENTS - START-->
							<div v-for="(additionalContentItem, nameadditionalcontent) in contentItem.additional_contents" :key="nameadditionalcontent" >
								<v-row no-gutters>
									<v-col cols="12" md="6" class="pl-8 font-weight-bold">
										<span class="font-weight-bold">{{$root.findTranslationInList(additionalContentItem.name)}}</span>
									</v-col>
									<v-col cols="12" md="6">
										{{additionalContentItem.price.currency}}&nbsp;{{ $root.formatPrice(getQuantityServiceContent(item.service_id, namecontent, nameadditionalcontent) * additionalContentItem.price.value)}}
										<span v-if="additionalContentItem.period">&nbsp;{{$t('lbl.contentPrice_' + additionalContentItem.period)}}</span>
									</v-col>
								</v-row>
								
							</div>
							<!-- PRICE QUOTATION - ADDITIONAL CONTENTS - END -->
							
						</div>
						<!-- PRICE QUOTATION - CONTENTS - END -->
						
						<v-divider></v-divider>
					</div>
				</div>
				
				
			</v-card-text>
		</v-card>

		<div v-else>
			<span class="font-weight-bold" >{{ $t('err.noelem') }}</span>
		</div>
	</div>
	
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
	i18n,
    data: () => ({
		estimate_obj: null,
		priceQuotation: null,
    }),
    props: ['orgitem', 'prjitem', 'servicesList'],
	created() 
	{
		
	},
    mounted() 
	{
		//=== START LISTEN EVENTS
		events.$on(constants.EVENT_DO_INIT_PRICE_QUOTATION, (prjObj, servicesList) => {
			this.initPriceQuotation(prjObj, servicesList);
		});

		//=== SE IL PROGETTO VIENE CARICATO PRIMA DELL EVENTO
		if(!this.isEmptyObj(this.prjitem) && !this.isEmptyObj(this.prjitem.services) && !this.isEmptyObj(this.servicesList) && Array.isArray(this.servicesList) && this.servicesList.length > 0 )
		{
			this.initPriceQuotation(this.prjitem, this.servicesList);
		}
	},
	destroyed() 
	{
		//=== STOP LISTEN EVENTS
		events.$off(constants.EVENT_DO_INIT_PRICE_QUOTATION);
	},
    methods: 
	{	
		initPriceQuotation(prjObj, servicesList)
		{
			this.priceQuotation= [];
			if(!this.isEmptyObj(prjObj) && !this.isEmptyObj(prjObj.services))
			{
				
				for (var i = 0; i < prjObj.services.length; i++) 
				{
					var serviceObj = prjObj.services[i];	
				
					var obj2add = this.getEmptyPriceQuotationElement();
					obj2add.service_id = serviceObj.service_id;
					
					if(prjObj.state == constants.PRJ_STATUS_DONE)
					{
						// PRENDO OGGETTO SERVIZIO DA PROGETTO
						obj2add.service = Object.assign({}, serviceObj.service);
					} 
					else 
					{
						// PRENDO OGGETTO SERVIZIO DA CATALOGO
						obj2add.service = this.findServiceObjInCatalogue(serviceObj.service_id, servicesList);
					}
					obj2add.notes = Object.assign({}, serviceObj.notes);
					obj2add.contents_data = Object.assign({}, serviceObj.contents_data);
					
					this.priceQuotation.push(obj2add);
				}
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.generic')+ " 01");
			}

			//INIT TOTALI
			if(prjObj.state == constants.PRJ_STATUS_DONE)
			{
				this.estimate_obj = this.calculateEstimate(this.prjitem.services, this.prjitem.services, false);
			} 
			else 
			{
				this.estimate_obj = this.calculateEstimate(this.prjitem.services, this.servicesList, true);
			}
		},
		getQuantityServiceContent(serviceId, namecontent, additionalnamecontent)
		{
			var itemInPriceQuotation = this.findServiceObjInPriceQuotation(serviceId);
			if(!this.isEmptyObj(itemInPriceQuotation) )
			{
				return this.getQuantityServiceContentByServiceObjWithContentData(itemInPriceQuotation, namecontent, additionalnamecontent, 0);
			} 
			else 
			{
				return 0;
			}
			
		},
		findServiceObjInPriceQuotation(serviceId)
		{
			for (var i = 0; i < this.priceQuotation.length; i++) 
			{
				var serviceObj = this.priceQuotation[i];	
				
				if(serviceObj.service_id == serviceId)
				{
					return serviceObj;
				}
			}
			return null;
		},
		getEmptyPriceQuotationElement(){
			var obj =  { 
                "service_id": null, 
				"service": null,
                "notes": {
                    "it_IT": ""
                },
                "contents_data":{}
			}
			return obj;	
        },
		projectPdfDownload()
		{
			var url2go = constants.ENDPOINT_GATEWAY_PROJECT_PDF;
			url2go += '?orgId='+this.orgitem.organization_id+'&prjId='+this.prjitem.project_id;
			if(i18n.locale == 'en_US')
			{
				url2go += '&lang=en_US';	
			} else {
				url2go += '&lang=it_IT';
			}
			url2go += '&accessToken='+this.getUserAccessToken();
			//alert(url2go);
			//console.log(url2go);
			location.replace(url2go);
		}
	}
}
</script>